module.exports = __webpack_public_path__ + "static/media/money.8800d6e8.svg";